import { render } from "./RepairsItem.vue?vue&type=template&id=1bafe894"
import script from "./RepairsItem.vue?vue&type=script&lang=js"
export * from "./RepairsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__